<template>
  <vx-card title="Personal Referral Message" class="mb-base">
    <div class="vx-row">
      <div class="vx-col flex account-info-col-1 w-full text-center">
        <vs-alert color="primary">
          <p>You can override the default message sent along with your referrals for each supported language.</p>
        </vs-alert>
      </div>
    </div>
    <div class="vx-row pt-5 mt-5">
      <vs-tabs alignment="fixed">
        <vs-tab v-for="locale in profileResource.$getEmbedded('locales')" :label="locale.name" :key="locale.id">
          <profile-default-message-locale :profile-resource="profileResource" :locale-resource="locale"
                                          @updated="onUpdated"/>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import ProfileDefaultMessageLocale from '@/views/app/profile/profile-default-message-locale';

export default    {
  name: 'profile-default-message',
  components: {ProfileDefaultMessageLocale},
  props: {
    profileResource: ResourceImpl
  },
  methods: {
    onUpdated () {
      this.$emit('updated');
    }
  }
};
</script>

<style scoped>

</style>
